import { GeneratorResult } from '@pressreader/appstore';
import { getErrorAlertContent, localizedString } from '@pressreader/resources';

import { openAlertOk } from './open.alert.ok';

type AlertOkOptions = Parameters<typeof openAlertOk>[0];

export type AlertOkExtraOptions = Omit<AlertOkOptions, 'message'>;

export interface ErrorWithResourceKey {
    message: string;
    resourceKey?: string;
}

export function* showErrorAlert(errorOrMessage?: ErrorWithResourceKey | string, options?: AlertOkExtraOptions): GeneratorResult<void> {
    yield openAlertOk({
        ...options,
        ...getErrorAlertContent(errorOrMessage),
    });
}

export function* showAlertFromResourceKey(resourceKey: string, options?: AlertOkExtraOptions) {
    const message = localizedString(resourceKey);

    yield openAlertOk({
        message,
        ...options,
    });
}
